import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { TypeaheadService } from '../../../services/typeahead.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-component-alternative',
  templateUrl: './component-alternative.component.html',
  styleUrls: ['./component-alternative.component.css']
})
export class ComponentAlternativeComponent implements OnInit {
    prodId;

    compKeyno;

    componentAlternativeKeyno;

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    public alternateProductIdButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.edit!.alternate_prod_keyno ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
        this.compKeyno = this.stateService.getStateParams()['comp_keyno'];
        this.componentAlternativeKeyno = this.stateService.getStateParams()['componentalternative_keyno'];
    }

    private async loadEdit() {
        if (!!this.prodId && !!this.compKeyno && !!this.componentAlternativeKeyno) {
            this.edit = (await this.datatask.Post(2404, {
                prod_id: this.prodId,
                comp_keyno: this.compKeyno,
                componentalternative_keyno: this.componentAlternativeKeyno
            }))[0];
        }
    }

    public searchAlternateProductNames = () => {
        return this.typeahead.lookUpProducts({ prod_name: this.edit?.alternate_prod_name ?? '' });
    }

    public onAlternateProductNameSelected(item?: Item): void {
        if (!!this.edit) {
            this.edit.alternate_prod_id = item?.item_id ?? '';
            this.edit.alternate_prod_name = item?.item_name ?? '';
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2405, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2406, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    prod_id: string;
    prod_name: string;
    comp_keyno: string;
    prod_keyno: string;
    componentalternative_keyno: string;
    alternate_prod_id: number | string;
    alternate_prod_name: string;
    alternate_prod_keyno: string;
}
